/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_RecentInputs */

const en_us2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent search`)
};

const pt_br2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca recente`)
};

const es_419_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda reciente`)
};

const pt_pt2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa recente`)
};

const fr_fr2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche récente`)
};

const de_de2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Suche`)
};

const it_it2_search_preview_recent = /** @type {(inputs: Search_Preview_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca recente`)
};

/**
* | output |
* | --- |
* | "Recent search" |
*
* @param {Search_Preview_RecentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_recent = /** @type {((inputs?: Search_Preview_RecentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_RecentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_recent(inputs)
	if (locale === "es-419") return es_419_search_preview_recent(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_recent(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_recent(inputs)
	if (locale === "de-DE") return de_de2_search_preview_recent(inputs)
	if (locale === "it-IT") return it_it2_search_preview_recent(inputs)
	return en_us2_search_preview_recent(inputs)
});
export { search_preview_recent as "search.preview_recent" }